import { addons } from '@storybook/manager-api';
import acpTheme from './acptheme';

addons.setConfig({
  theme: acpTheme,
  sidebar: {
    showRoots: false,
  },
});
